import React, { Component } from "react";
import queryString from "query-string";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { logout } from "../../../actions/user";
import api from "../../../utils/api";
import Header from "../../ui/header/header";
import { Link } from "react-router-dom";
import Grid from "../../ui/grid/grid";
import "../../ui/base/base.css";
import styles from "./homePage.css";

class HomePage extends Component {
	constructor() {
		super();

		this.state = {
			bookmarks: [],
			hasMoreItems: true
		};
	}

	async getBookmarks() {
		const bookmarks = this.state.bookmarks;
		const offset = bookmarks.length;
		const reqUrl = queryString.parse(this.props.location.search).q;
		const { bookmarks: newBookmarks, hasMoreItems } = await api.bookmark.all(
			reqUrl,
			offset
		);

		newBookmarks.map(bookmark => {
			return bookmarks.push(bookmark);
		});

		this.setState({ bookmarks, hasMoreItems });
	}

	componentDidUpdate(prevProps) {
		// If search query has changed
		if (prevProps.location.search !== this.props.location.search) {
			// Remove previous bookmarks, then fetch new ones
			// https://stackoverflow.com/questions/38558200/react-setstate-not-updating-immediately
			this.setState({ bookmarks: [] }, this.getBookmarks);
		}
	}

	render() {
		const { bookmarks, hasMoreItems } = this.state;
		const searchQuery = queryString.parse(this.props.location.search).q;

		return (
			<div>
				<Header history={this.props.history} searchQuery={searchQuery} />
				<div className={styles.grid}>
					{/* If there's no bookmarks show a nice empty state */}
					{bookmarks.length === 0 && !hasMoreItems ? (
						<div className={styles.emptyState}>
							<Link to="/bookmark/create">Create your first bookmark</Link>
						</div>
					) : (
						<Grid
							loadMore={this.getBookmarks.bind(this)}
							hasMore={hasMoreItems}
							items={bookmarks}
						/>
					)}
				</div>
			</div>
		);
	}
}

HomePage.propTypes = {
	isAuthenticated: PropTypes.bool.isRequired,
	logout: PropTypes.func.isRequired
};

function mapStateToProps(state) {
	return {
		isAuthenticated: !!state.user.token
	};
}

export default connect(
	mapStateToProps,
	{ logout }
)(HomePage);



// WEBPACK FOOTER //
// ./src/components/pages/homePage/homePage.js